import React, { useState, useEffect } from "react";
import '../../sass/components/flexibleModules/_components.heroSectionWithFormAndThumbnail.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import MarketoForm from '../marketo/marketoForm';

const HeroSectionWithFormAndThumbnail = ({ data }) => {

    useEffect(() => {
        var scriptOne = document.createElement('script');
        scriptOne.src = `https://fast.wistia.com/embed/medias/no7mn5r89i.jsonp`;
        scriptOne.async = 'async';
        document.getElementsByTagName('head')[0].appendChild(scriptOne);
        var scriptTwo = document.createElement('script');
        scriptTwo.src = 'https://fast.wistia.com/assets/external/E-v1.js';
        scriptTwo.async = 'async';
        document.getElementsByTagName('head')[0].appendChild(scriptTwo);
    }, []);

    return (
        <div className={`cp-heroSectionWithFormAndThumbnail l-graphicCheck${data.backgroundGraphic} ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ backgroundColor: `${data.backgroundGraphic === 'no' && data.backgroundColor ? data.backgroundColor : ""}` }}>
            <div className="cp-heroSectionWithFormAndThumbnail__inner l--flex" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                <div className="cp-heroSectionWithFormAndThumbnail__left">
                    {data.heroSectionWithFormAndThumbnailContentFields &&
                        <>
                            {data.heroSectionWithFormAndThumbnailContentFields.map((content, index) => (
                                <React.Fragment key={index}>
                                    {content.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithFormAndThumbnail_HeroSectionWithFormAndThumbnailContentFields_FlexiHeaderField' &&
                                        <>
                                            {content.categoryHeader &&
                                                <h3>{content.categoryHeader}</h3>
                                            }
                                            {content.header &&
                                                <h1>{content.header}</h1>
                                            }
                                            {content.subHeader &&
                                                <h2>{content.subHeader}</h2>
                                            }
                                        </>
                                    }
                                    {content.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithFormAndThumbnail_HeroSectionWithFormAndThumbnailContentFields_FlexiTeaserField' &&
                                        <>
                                            {content.teaser &&
                                                <div className="l--content" dangerouslySetInnerHTML={{ __html: content.teaser }} />
                                            }
                                        </>
                                    }
                                    {content.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithFormAndThumbnail_HeroSectionWithFormAndThumbnailContentFields_FlexiImageOrVideoField' &&
                                        <>
                                            {content.imageOrVideo &&
                                                <>
                                                    {content.imageOrVideo === 'image' ?
                                                        <>
                                                            {content.imageLink ?
                                                                <a className="l--imageLink" href={content.imageLink.url} target={content.imageLink.target}>
                                                                    <GatsbyImage style={{ maxWidth: `${content.imageMaxWidth ? content.imageMaxWidth : ""}px` }} image={getImage(content.image.gatsbyImage)} alt={content.image.altText} />
                                                                </a>
                                                                :
                                                                <GatsbyImage style={{ maxWidth: `${content.imageMaxWidth ? content.imageMaxWidth : ""}px` }} image={getImage(content.image.gatsbyImage)} alt={content.image.altText} />
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            {content.videoId &&
                                                                <div className="l-embedWrap">
                                                                    <div className={`wistia_embed wistia_async_${content.videoId}`}>&nbsp;</div>
                                                                </div>
                                                            }
                                                        </>
                                                    }
                                                </>
                                            }
                                        </>
                                    }
                                    {content.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HeroSectionWithFormAndThumbnail_HeroSectionWithFormAndThumbnailContentFields_FlexiBulletPoints' &&
                                        <>
                                            {content.bulletPoints &&
                                                <div className="l-bulletSectionWrap">
                                                    {content.bulletPoints.map((bullet, index) => (
                                                        <div className="l-bulletSection" key={index}>
                                                            {bullet.header &&
                                                                <h4>{bullet.header}</h4>
                                                            }
                                                            {bullet.teaser &&
                                                                <p>{bullet.teaser}</p>
                                                            }
                                                        </div>
                                                    ))}
                                                </div>
                                            }
                                        </>
                                    }
                                </React.Fragment>
                            ))}
                        </>
                    }
                </div>
                <div className="cp-heroSectionWithFormAndThumbnail__right">
                    {data.heroSectionImageAboveTheForm &&
                        <GatsbyImage image={getImage(data.heroSectionImageAboveTheForm.gatsbyImage)} alt={data.heroSectionImageAboveTheForm.altText} />
                    }
                    {data.heroSectionWithFormAndThumbnailMarketoVsCustomFormHeader &&
                        <h3>{data.heroSectionWithFormAndThumbnailMarketoVsCustomFormHeader}</h3>
                    }
                    {data.heroSectionWithFormAndThumbnailMarketoVsCustomForm === 'marketo' ?
                        <MarketoForm data={data} ctabgcolor={data.heroSectionWithFormCtaButtonColor} externalLink={data.heroSectionFormLink} formSubmitPdf={data.heroSectionFormPdf} ctaOverride={data.heroSectionWithFormAndThumbnailMarketoVsCustomFormCtaOverride} formID={data.heroSectionWithFormAndThumbnailMarketoVsCustomFormId} formSubmitMessage={data.heroSectionWithFormAndThumbnailMarketoVsCustomFormThankYouMessage} formSubmitThankYouPage={data.heroSectionWithFormAndThumbnailMarketoThankYouPage} />
                        :
                        <>
                            {data.heroSectionWithFormAndThumbnailCustomForm &&
                                <div className="cp-embed" dangerouslySetInnerHTML={{ __html: data.heroSectionWithFormAndThumbnailCustomForm }} />
                            }
                        </>
                    }
                    {data.heroSectionWithFormAndThumbnailAdditionTextUnderTheForm &&
                        <div dangerouslySetInnerHTML={{ __html: data.heroSectionWithFormAndThumbnailAdditionTextUnderTheForm }} />
                    }
                </div>
            </div>
        </div>
    );
}

export default HeroSectionWithFormAndThumbnail;